class KlaviyoForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.input = this.querySelector('input[type="email"]');
    this.successBlock = this.querySelector('.m-footer__newsletter-success');

    this.apiKey = this.dataset.klaviyoApi;
    this.listId = this.dataset.klaviyoListId;

    this.init();
  }

  init() {
    if (!this.form) return;

    this.form.addEventListener('submit', (e) => this.handleSubmit(e));
  }

  async handleSubmit(e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    const email = this.input.value.trim();
    if (!email) return;

    const PUBLIC_KEY = this.apiKey;
    const LIST_ID = this.listId;

    await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${PUBLIC_KEY}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: '2024-10-15',
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: { email },
              },
            },
          },
          relationships: {
            list: {
              data: { type: 'list', id: LIST_ID },
            },
          },
        },
      }),
    })
      .then(() => {
        this.showSuccess();
      })
      .catch((e) => {
        console.error(e);
      });
  }

  showSuccess() {
    if (this.successBlock) {
      this.successBlock.style.display = 'flex';
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('klaviyo-form')) {
    customElements.define('klaviyo-form', KlaviyoForm);
  }
});
